import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, RefreshCcw } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

export const RebuildAll = ({ count }) => {
  const [st, setSt] = useState(null);
  const load = useCallback(() => http.get("/rebuild-kits").then((r) => setSt(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [load]);
  const go = async () => {
    try { const r = await http.post("/rebuild-kits"); toast.success(`${r.data.queued} kits queued — they rebuild one after another`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const cancel = async () => {
    try { const r = await http.post("/rebuild-kits/cancel"); toast.message(`${r.data.cancelled} waiting kits taken off the rebuild list`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (st?.waiting || st?.running) {
    return (
      <div data-testid="rebuild-all-status" className="inline-flex items-center gap-3 rounded-sm border border-[#C9A847]/50 bg-[#C9A847]/10 px-4 py-2.5 text-sm">
        <Loader2 size={15} className="animate-spin text-[#9A7B2C]" />
        <span>Rebuilding to the new standard{st.running ? ` — now: ${st.running.destination}` : ""} · {st.waiting} waiting</span>
        {st.waiting > 0 && <button data-testid="rebuild-all-cancel" onClick={cancel} className="text-xs underline text-stone-600 hover:text-black">Stop the rest</button>}
      </div>
    );
  }
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button data-testid="rebuild-all-button" className="inline-flex items-center gap-2 rounded-sm border border-[#2B2A26] px-5 py-3 font-bold text-[#2B2A26] hover:bg-[#2B2A26] hover:text-white transition-colors">
          <RefreshCcw size={16} /> Rebuild all kits
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="rebuild-all-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Rebuild every kit to the new research standard?</AlertDialogTitle>
          <AlertDialogDescription>
            Each of your {count} kits is rewritten from fresh venue research, one at a time. Each one uses AI credit,
            capped at $8 per kit. Live kits stay on sale with their current version until the rebuild finishes. Bespoke kits
            and standalone guides are left alone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="rebuild-all-no">Not now</AlertDialogCancel>
          <AlertDialogAction data-testid="rebuild-all-yes" onClick={go}>Rebuild all</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
